import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import logo from "@/assets/logo-fd-round.jpeg";


const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const next = searchParams.get("next") ?? "/admin/dashboard";

  useEffect(() => {
    const checkSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        const target = next.startsWith("/") ? next : "/admin/dashboard";
        navigate(target);
      }
    };
    checkSession();
  }, [navigate, next]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) {
      toast.error("Credenciales incorrectas");
    } else {
      const target = next.startsWith("/") ? next : "/admin/dashboard";
      navigate(target);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Helmet>
        <title>Acceso de Administración de Novedades | Federico Duronio</title>
        <meta name="description" content="Panel privado para gestionar las novedades publicadas en federicoduronio.com." />
        <meta name="robots" content="noindex,nofollow" />
        <link rel="canonical" href="https://federicoduronio.com/admin" />
      </Helmet>
      <Card className="w-full max-w-md p-8 space-y-6">
        <div className="flex flex-col items-center gap-4">
          <img src={logo} alt="Federico Duronio" className="w-20 h-20 rounded-full object-cover" />
          <h1 className="text-2xl font-bold text-foreground">Acceso al panel de gestión de novedades</h1>
          <p className="text-muted-foreground text-sm text-center">Acceso exclusivo para gestionar novedades</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Contraseña</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <Button type="submit" variant="premium" className="w-full" disabled={loading}>
            {loading ? "Entrando..." : "Entrar"}
          </Button>
        </form>
        <Button variant="ghost" className="w-full" onClick={() => navigate("/home")}>
          ← Volver a la web
        </Button>
      </Card>
    </div>
  );
};

export default AdminLogin;
